// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.flag-icon[data-v-693c0f9a] {\n    width: 20px;\n    height: 15px;\n    margin-right: 8px;\n}\n.search-container[data-v-693c0f9a] {\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 1;\n    padding: 8px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
